import { memo, type ReactNode } from 'react';

import { GEOLOCATION_STEPS } from '@/features/Popup/constants';
import { GeolocationStepsType } from '@/features/Popup/types';
import {
  getIconProductType,
  IconProductType,
} from '@/features/GenericIcon/types';
import { BRANDS } from '@/utilities/constants/game';

import geolocationRefreshSpinner from './assets/geolocation-refresh-spinner.svg';
import geolocationRefreshSuccess from './assets/geolocation-refresh-success.svg';
import geolocationRefreshError from './assets/geolocation-refresh-error.svg';
import geolocationRefreshErrorMs from './assets/geolocation-refresh-error-ms.svg';
import geolocationRefreshSuccessMs from './assets/geolocation-refresh-success-ms.svg';

import './GeolocationRefreshStatusIndicator.scss';

type BrandKey = typeof BRANDS.FANDUEL | typeof BRANDS.MOHEGANSUN;

const getStatusIcon = (src: string, spin = false) => (
  <div className="status-icon">
    <img className={spin ? 'spin' : undefined} src={src} alt="Status Icon" />
  </div>
);

const statusIcons: Record<GeolocationStepsType, Record<BrandKey, ReactNode>> = {
  [GEOLOCATION_STEPS.LOADING]: {
    [BRANDS.MOHEGANSUN]: getStatusIcon(geolocationRefreshSpinner, true),
    [BRANDS.FANDUEL]: getStatusIcon(geolocationRefreshSpinner, true),
  },
  [GEOLOCATION_STEPS.SUCCESS]: {
    [BRANDS.MOHEGANSUN]: getStatusIcon(geolocationRefreshSuccessMs),
    [BRANDS.FANDUEL]: getStatusIcon(geolocationRefreshSuccess),
  },
  [GEOLOCATION_STEPS.ERROR]: {
    [BRANDS.MOHEGANSUN]: getStatusIcon(geolocationRefreshErrorMs),
    [BRANDS.FANDUEL]: getStatusIcon(geolocationRefreshError),
  },
};

const toBrandKey = (product: IconProductType): BrandKey =>
  product === 'mohegansun' ? BRANDS.MOHEGANSUN : BRANDS.FANDUEL;

export const GeolocationRefreshStatusIndicator = memo(
  ({ status }: { status: GeolocationStepsType }) => {
    const brand = toBrandKey(getIconProductType());

    return (
      <div className="geolocation-refresh-indicator-icon">
        {statusIcons[status][brand]}
      </div>
    );
  },
);

GeolocationRefreshStatusIndicator.displayName =
  'GeolocationRefreshStatusIndicator';
